var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Stack, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
export var SeasonForm = function (_a) {
    var _b, _c;
    var season = _a.season, onSubmit = _a.onSubmit;
    var _d = useForm({
        defaultValues: {
            name: (_b = season === null || season === void 0 ? void 0 : season.name) !== null && _b !== void 0 ? _b : "",
            description: (_c = season === null || season === void 0 ? void 0 : season.description) !== null && _c !== void 0 ? _c : "",
        },
    }), control = _d.control, handleSubmit = _d.handleSubmit, errors = _d.formState.errors;
    return (_jsx(Box, { component: "form", onSubmit: handleSubmit(onSubmit), noValidate: true, role: "form", sx: { mt: 1 }, children: _jsxs(Stack, { spacing: 2, children: [_jsx(Controller, { name: "name", control: control, rules: { required: "Season Name is required" }, render: function (_a) {
                        var field = _a.field;
                        return (_jsx(TextField, __assign({}, field, { label: "Season Name", required: true, margin: "normal", fullWidth: true, error: !!errors.name, helperText: errors.name ? errors.name.message : "" })));
                    } }), _jsx(Controller, { name: "description", control: control, render: function (_a) {
                        var _b, _c;
                        var field = _a.field;
                        return (_jsx(TextField, __assign({}, field, { label: "Description", multiline: true, minRows: 3, margin: "normal", fullWidth: true, error: !!errors.description, helperText: ((_c = (_b = errors.description) === null || _b === void 0 ? void 0 : _b.message) === null || _c === void 0 ? void 0 : _c.toString()) || "" })));
                    } }), _jsx(Button, { type: "submit", fullWidth: true, variant: "contained", sx: { mt: 3, mb: 2 }, children: season ? "Update" : "Create" })] }) }));
};
